module.exports = __webpack_public_path__ + "img/opalines-img1.167e682d.png";